// extracted by mini-css-extract-plugin
export default {"action":"action___B8wu0r2","download":"download___B8wu0r2","icon":"icon___B8wu0r2","hide":"hide___B8wu0r2","warn":"warn___B8wu0r2"};